import { render } from "./BoxWithDetail.vue?vue&type=template&id=c81cf05e&scoped=true&ts=true"
import script from "./BoxWithDetail.vue?vue&type=script&lang=ts"
export * from "./BoxWithDetail.vue?vue&type=script&lang=ts"

import "./BoxWithDetail.vue?vue&type=style&index=0&id=c81cf05e&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81cf05e"]])

export default __exports__